import styled from "styled-components";

const CheckButton = styled.button`
  width: 7rem;
  height: 4rem;
  background: #5f95e5;
  color: #ffffff;
  border: none;
  cursor: pointer;
`;

export default CheckButton;
